<template>
  <div
    class="config-panel  absolute top-[3.25rem] right-0 w-64 p-0 surface-card dark:bg-surface-900 border pt-2 border-surface border-round-lg origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]">
    <div v-if="userData && userData.user" class="flex flex-column gap-4">
      <div class="flex flex-column align-items-center justify-content-center mx-4">
        <Avatar 
            :label="`${(userData.user as unknown as UserType).name[0]}${(userData.user as unknown as UserType).surname[0]}`" 
            class="cursor-pointer mr-2 bg-blue-400 text-white" 
            size="xmedium"
            shape="circle"
          />
          <div v-if="userData && userData.user" class="white-space-nowrap mt-2">
            <span class="text-400 text-xs block">Benvenuto,</span>
            <span>{{ (userData.user as unknown as UserType).name }} {{ (userData.user as unknown as UserType).surname }}</span>
          </div>
      </div>
      <div class="mx-4">
        <!-- <NuxtLink href="/procedure/impostazioni" class="w-100 flex align-items-center border-round-lg hover:surface-100 transition-colors transition-duration-150 p-2">
          <i class="pi pi-sliders-h mr-2"></i>
          <span>Impostazioni</span>
        </NuxtLink>
        <NuxtLink href="#" class="w-100 flex align-items-center border-round-lg hover:surface-100 transition-colors transition-duration-150 p-2">
          <i class="pi pi-book mr-2"></i>
          <span>Manuale</span>
        </NuxtLink> -->
        <NuxtLink  @click="" href="mailto:support@smart-flow.it" class="w-100 flex align-items-center border-round-lg hover:surface-100 transition-colors transition-duration-150 p-2">
          <i class="pi pi-question mr-2"></i>
          <span>Assistenza</span>
        </NuxtLink>
      </div>
      <div class="bg-red-500 text-white flex justify-content-center align-items-center px-4 py-2 border-round-bottom-lg" >
        <a class="cursor-pointer" @click="signOut({ callbackUrl: `${config.baseURL}/login`, external: true })">Esci</a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { UserType } from '~/types/user';

const { layoutConfig, setPrimary, setSurface, setPreset, isDarkMode, setMenuMode } = useLayout();
const {public: config} = useRuntimeConfig();
const { data: userData, getSession, signOut } = useAuth();
const emit = defineEmits(['item:click']);


// TODO: emit to close menu

</script>
<style lang="scss">
  .config-panel{
    z-index: 1000;
  }
</style>